import { render } from "./farmCord.vue?vue&type=template&id=f8596cf8&scoped=true"
import script from "./farmCord.vue?vue&type=script&lang=js"
export * from "./farmCord.vue?vue&type=script&lang=js"

import "./farmCord.vue?vue&type=style&index=0&id=f8596cf8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8596cf8"]])

export default __exports__